export default "__VITE_ASSET__3147b049__"